import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import useSteps from '../StepContext/useSteps';
import { Button, Spinner } from 'reactstrap';
import { useFormikContext } from 'formik';
import { goalSettings } from '../types';
import { useToast } from '@front-activerse/common-components';
import createRequest from '../helpers/createRequest';
import { useTranslator, useAppContext } from '@front-activerse/common-components';

const NextButton: React.FC = () => {
  const { t } = useTranslator();
  const { toastError } = useToast();
  const { nextStep, currentMainStep, currentStep, shouldBackendValidate, validateGoalSettings } =
    useSteps();
  const [loading, setLoading] = useState(false);
  const location = useLocation();

  const {
    consts: { SLIDE_ROUTES_DURATION },
  } = useAppContext();

  const { values, errors, setFieldError, setFieldTouched } = useFormikContext<goalSettings>();
  const navigate = useNavigate();

  const validate = async () => {
    let isError = false;

    if (shouldBackendValidate) {
      try {
        setLoading(true);
        const validationResult: any = await validateGoalSettings(createRequest(values));
        const currentMainStepErrors = validationResult.details;

        let currentStepError: any = '';

        if (currentMainStep === 'goal') {
          if (currentStep === 'weightValue') {
            currentStepError = currentMainStepErrors.find(
              (err: any) => err.fieldName === 'weight.value'
            );
          } else if (currentStep === 'goalWeightValue') {
            currentStepError = currentMainStepErrors.find(
              (err: any) => err.fieldName === 'goalWeight.value'
            );

            if (currentStepError) currentStepError.fieldName = 'goalWeightValue';
          }
        }

        if (currentStepError) {
          setFieldError(currentStep, currentStepError.messages[0]);
          setFieldTouched(currentStep, true, false);

          isError = true;
        }
      } catch (err) {
        console.log('err', err);
        toastError();
        isError = true;
      } finally {
        setLoading(false);
      }
    }
    return isError;
  };

  const handleClick = async () => {
    const isError = await validate();

    if (!isError) {
      if (nextStep) {
        // Check if we're in all-settings context and build appropriate path
        const basePath = location.pathname.includes('/all-settings/')
          ? '/all-settings/goal-settings'
          : '/goal-settings';

        //navigate to the next step
        scrollToTopAndNavigate(`${basePath}/${nextStep}`);
      }
    }
  };

  const scrollToTopAndNavigate = (url: string) => {
    const el = document.querySelector('.layout') as HTMLInputElement;
    if (el.scrollTop) {
      el.scrollTo({ top: 0, behavior: 'smooth' });
      setTimeout(() => {
        navigate(url);
      }, +SLIDE_ROUTES_DURATION);
    } else {
      navigate(url);
    }
  };

  return (
    <Button
      color="primary"
      className="w-100"
      onClick={handleClick}
      disabled={
        loading ||
        Boolean(errors[currentStep as keyof goalSettings]) ||
        Boolean(!values[currentStep as keyof goalSettings])
      }
    >
      {loading ? (
        <>
          <Spinner size="sm" className="me-2">
            Loading...
          </Spinner>
          {t('goalSettings.nextButton')}
        </>
      ) : (
        t('goalSettings.nextButton')
      )}
    </Button>
  );
};

export default NextButton;
